// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"4997":"ca65a0a1c61535fd6c46","8750":"5eeec25b7bb3b399709f"}[chunkId] + ".css";
};